import { useHistory } from "react-router-dom";

const useChangeQuery = () => {
  const history = useHistory();
  // this method change query params of page
  const changeQueryParam = (page, coin1Symbol, coin2Symbol) => {
    // set url param
    let selectedSymbolIn = "";
    if (coin1Symbol) {
      selectedSymbolIn =
        typeof coin1Symbol === "string"
          ? coin1Symbol
          : `${coin1Symbol[0]}-${coin1Symbol[1]}`;
    }

    let selectedSymbolOut = "";
    if (coin2Symbol) {
      selectedSymbolOut =
        typeof coin2Symbol === "string"
          ? coin2Symbol
          : `${coin2Symbol[0]}-${coin2Symbol[1]}`;
    }

    let searchQuery = "";
    if (selectedSymbolIn && selectedSymbolOut) {
      searchQuery = `?tokenIn=${selectedSymbolIn}&tokenOut=${selectedSymbolOut}`;
    }

    if (selectedSymbolIn && !selectedSymbolOut) {
      searchQuery = `?tokenIn=${selectedSymbolIn}`;
    }

    if (!selectedSymbolIn && selectedSymbolOut) {
      searchQuery = `?tokenOut=${selectedSymbolOut}`;
    }
    console.log(page);
    console.log(searchQuery);
    // history.push({
    //   pathname: `/${page}`,
    //   search: searchQuery,
    // });
  };

  return [changeQueryParam];
};

export default useChangeQuery;
